import React from "react"
import DayPanel from "../components/DayPanel"

export default function SevenDay(props) {
    
    const panelList = () => {
        const dayData = props.daily;
        return dayData.map((item, index)=>{
            return <DayPanel
            key={index}
            unit={props.unit} 
            date={item.date}
            hitemp={Math.round(item.hitemp)}
            lowtemp={Math.round(item.lowtemp)}
            weatherdesc={item.weatherdesc}
            weathermain={item.weathermain}
            icon={item.weathericon}
            />
        })
    }

    return(
        <div className="Daily-Panel" id="seven-day">
        {panelList()} 
        </div>
    )
}